import { ComponentProps } from "react";
import DialogInOne from "src/components/DialogInOne";
import { Optional } from "src/features/common/types/OptionalType";
import { useDialogProviderContext } from "..";

type DialogInOneProps = ComponentProps<typeof DialogInOne>;
type DialogProviderInOneProps = Optional<DialogInOneProps, "self" | "onCancel">;

const Dialog = (props: DialogProviderInOneProps) => {
  const { isOpen, setIsOpen } = useDialogProviderContext();

  return (
    <DialogInOne
      self={{ open: isOpen, onClose: () => setIsOpen(false) }}
      onCancel={() => setIsOpen(false)}
      {...props}
    />
  );
};

export default Dialog;
